import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmbeddedInNativeShell } from 'app/utils/webviewAuth';
import { popThenReplace, useShellArrival } from 'app/hooks/useShellHistory';

const NativeShellCommands = () => {
  const navigate = useNavigate();
  useShellArrival();

  useEffect(() => {
    if (!isEmbeddedInNativeShell()) return undefined;

    const startTransaction = (rootPath?: string) =>
      popThenReplace(navigate, Infinity, rootPath, {
        state: { startTransaction: true },
      });

    window.__WEBVIEW_START_TRANSACTION__ = startTransaction;
    const pending = window.__WEBVIEW_PENDING_START_TRANSACTION__;
    if (pending) {
      delete window.__WEBVIEW_PENDING_START_TRANSACTION__;
      startTransaction(pending === true ? undefined : pending);
    }
    return () => {
      delete window.__WEBVIEW_START_TRANSACTION__;
    };
  }, [navigate]);

  return null;
};

export default NativeShellCommands;
